const APPSYNC_CONFIG = {
  region: process.env.REACT_APP_APPSYNC_REGION,
  url: process.env.REACT_APP_APPSYNC_URL,
  authenticationType: process.env.REACT_APP_APPSYNC_AUTH_TYPE,
};

export default APPSYNC_CONFIG;
